import { isElectronContext } from './isElectron';
import Vue from 'vue';

const isInstabetMx = window.location.hostname.includes('instabet.mx');
const isProd = process.env.NODE_ENV === 'production';
// const isScriptEnabled = true;
const isScriptEnabled = isInstabetMx && isProd && !isElectronContext();
const conv = '144188c2bb62a178';

export function conversion() {
  if (!isScriptEnabled) {
    return;
  }

  const quantScript = document.createElement('script');
  quantScript.async = true;
  quantScript.type = 'text/javascript';
  quantScript.src =
    (document.location.protocol == 'https:' ? 'https://secure' : 'http://edge') + '.quantserve.com/quant.js';
  document.getElementsByTagName('head')[0].appendChild(quantScript);

  const upPixelScript = document.createElement('script');
  upPixelScript.type = 'text/javascript';
  upPixelScript.addEventListener('load', function() {
    cntrUpTag && cntrUpTag.track('cntrData', 'c3ca354c85dc96d7');
  });
  upPixelScript.src = 'https://up.pixel.ad/assets/up.js?um=1';
  document.getElementsByTagName('head')[0].appendChild(upPixelScript);
}

export function insertConversion(amount) {
  if (!isScriptEnabled) {
    return;
  }

  const img = document.createElement('img');
  img.src = `https://clickserv.sitescout.com/conv/${conv}/${amount}`;
  img.height = 1;
  img.width = 1;
  document.body.appendChild(img);
}

export function insertQEvent(params) {
  window._qevents = window._qevents || [];
  window._qevents.push(params);
}

export function insertGestrkScript(gestrkSubId, txid) {
  if (!isScriptEnabled) {
    return;
  }

  if (!gestrkSubId) {
    console.log('gestrkSubId not exists');
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://go.gestrk.com/conversion.js?cid=${gestrkSubId}&txid=${txid}`;
  document.getElementsByTagName('head')[0].appendChild(script);
}

Vue.prototype.$pixelAd = {
  conversion,
  insertConversion,
  insertQEvent,
  insertGestrkScript,
};
